/* eslint-disable camelcase */
/*
 * @Author: edvardchen
 * @Date: 2017-09-28 14:41:29
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-11-25 16:28:11
 */

// @flow
import _ from 'lodash';
import qblogin from '@tencent/qblogin';
import cookies from 'js-cookie';
import querystring from 'query-string';
import {
  subscribe as subscribeAPI,
  unsubscribe as unsubscribeAPI,
  fetchRecommandCircles,
  check as checkAPI,
  // reportCirclePV,
  checkWelfareInfo,
} from '../../fetchers/subscribe_client';
import { getGSPProxy, getPushWelfare, getProfileMatch } from '../../fetchers/user_client';
import { type Dispatch, type GetState, type User, type Action, initialState } from '../types';

import { localStorage, isomorphicConfig, isAndroid, isIOS, postMessage } from '../../utility';
import KdBigTReport from '../../entries/kdarticle/bigTReport';
import { listenToPostMessageReady } from '../../entries/RN-postMessage';

export * from '../login';
const RESET = 'user/RESET';
const UPDATE = 'user/UPDATE';
const CHECK_SUBSCRIBED = 'user/CHECK_SUBSCRIBED';
const SUBSCRIPTION_TOGGLE = 'user/SUBSCRIPTION_TOGGLE';
const SUBSCRIPTION_BATCH_UPDATE = 'user/SUBSCRIPTION_BATCH_UPDATE';
const RECOMMANDCIRCLES = 'user/RECOMMANDCIRCLES';
const TOGGLE_RECOMMCIRCLES = 'user/TOGGLE_RECOMMCIRCLES';
const RESETWELFARE = 'user/RESETWELFARE';
const UPDATEGSP = 'user/UPDATEGSP';
const SETPUSHWELFARE = 'user/PUSHWELFARE';
const SETRMPINFO = 'user/RMPINFO';
const SETFOLLOWSTATUS = 'user/SET_FOLLOW_STATUS';
const SETPRAISESTATUS = 'user/SET_PRAISE_STATUS';
const SETKDREPORTINSTANCE = 'user/SET_KD_REPORT_INSTANCE';
export const batchUpdateSubscription = (payload: *) => ({
  type: SUBSCRIPTION_BATCH_UPDATE,
  payload,
});
const reducer = (state: User, { type, payload }: Action) => {
  switch (type) {
    case RESET: {
      let { subscriptions = {} } = state;

      subscriptions = _.transform(subscriptions, (result, value, key) => {
        /* eslint-disable no-param-reassign */
        result[key] = false;
      });

      return {
        ...initialState.user,
        ...payload,
        subscriptions,
      };
    }
    case UPDATE:
      return {
        ...state,
        ...payload,
      };
    case SUBSCRIPTION_BATCH_UPDATE:
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          ...payload,
        },
      };
    case CHECK_SUBSCRIBED: {
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          hasCheckSubscribed: true,
        },
      };
    }
    case SUBSCRIPTION_TOGGLE: {
      if (!payload) {
        return state;
      }
      const { id, value } = payload;
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          [id]: value,
        },
      };
    }
    case RECOMMANDCIRCLES: {
      if (!payload) {
        return state;
      }
      return {
        ...state,
        recommandCircles: payload,
      };
    }
    case TOGGLE_RECOMMCIRCLES: {
      return {
        ...state,
        recommandCirclesActive: payload !== undefined ? payload : !state.recommandCirclesActive,
      };
    }
    case RESETWELFARE:
      return {
        ...state,
        welfareInfo: { ...state.welfareInfo, ...payload },
      };
    case UPDATEGSP:
      return {
        ...state,
        gspObject: payload,
      };
    case SETPUSHWELFARE:
      return {
        ...state,
        pushWelfare: payload,
      };
    case SETRMPINFO:
      return {
        ...state,
        RMPObject: payload,
      };
    case SETFOLLOWSTATUS:
      return {
        ...state,
        followStatus: payload,
      };
    case SETPRAISESTATUS:
      return {
        ...state,
        praiseStatus: payload,
      };
    case SETKDREPORTINSTANCE:
      return {
        ...state,
        kdBigTReportInstance: payload,
      };
    default:
      return state;
  }
};
// 校验福利中心的缓存数据是否过期
const welfareInfoIsTimeLimit = (key: string) => {
  let isLimit = true;
  const info = localStorage.getItem(key);
  console.log('福利中心-获取缓存', info);
  if (info) {
    const { code, time } = info || {};
    if (code && time && new Date().getDate() === new Date(time).getDate()) {
      console.log('福利中心', '数据未过期');
      isLimit = false;
    }
  }
  return isLimit;
};
export default reducer;

export const reset = (user: ?Object) => ({ type: RESET, payload: user });
export const update = (user: ?Object) => ({ type: UPDATE, payload: user });
export const updateCircles = (circles: []) => ({ type: RECOMMANDCIRCLES, payload: circles });
export const toggleRecommCircles = (payload?: boolean) => ({ type: TOGGLE_RECOMMCIRCLES, payload });
// 通知关注状态
export const synchState = ({
  id,
  state,
  followCount,
  loginTips,
}: {
  id: string,
  state: boolean,
  followCount: number,
  loginTips: boolean,
}) => {
  /* const handle = _.get(global, 'browser.coolread.toggleSubscription');
  if (handle) {
    handle(
      {
        subscribed: !state, // 历史原因
        tagId: id,
        // gsId: String(gsId),
        // tagName: String(data.name),
        // qbUrl: qbUrl,
        // webUrl: webUrl
      },
      (ret) => {
        console.log('toggleSubscription return', ret);
      },
    );*/
  postMessage({
    func: 'coolread.toggleSubscription',
    data: {
      subscribed: !state, // 历史原因
      tagId: id,
      followCount,
      loginTips,
    },
  });
  const notifyFollowComplete = _.get(global, 'browser.circle.notifyFollowComplete');
  if (!notifyFollowComplete) {
    return;
  }
  const param = {
    circleID: id,
    status: state ? 1 : 0,
  };
  notifyFollowComplete(param);
};
export const updateGSP = (payload: Object) => ({ type: UPDATEGSP, payload });
export const setPushWelfare = (payload: Object) => ({ type: SETPUSHWELFARE, payload });
export const checkSubscribed = () => ({ type: CHECK_SUBSCRIBED });
export const subscribe = (id: string) => ({
  type: SUBSCRIPTION_TOGGLE,
  payload: { id, value: true },
});
export const unsubscribe = (id: string) => ({
  type: SUBSCRIPTION_TOGGLE,
  payload: { id, value: false },
});
export const resetWelfareInfo = (info: Object) => ({ type: RESETWELFARE, payload: info });
export const setRMPInfo = (info: Object) => ({ type: SETRMPINFO, payload: info });
export const setFollowStatus = (follow: boolean) => ({
  type: SETFOLLOWSTATUS,
  payload: follow,
});
export const setPraiseStatus = (praise: boolean) => ({
  type: SETPRAISESTATUS,
  payload: praise,
});
export const setKdReportInstance = (instance: KdBigTReport) => ({
  type: SETKDREPORTINSTANCE,
  payload: instance,
});
export const makeRecheckSubscriptions = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    user: { qbid },
    article: { fusionId },
    entry = '',
  } = getState();
  console.debug('=================makeRecheckSubscriptions关注状态1', qbid, fusionId);
  if (!fusionId || entry === 'kdarticle') {
    return;
  }
  const { result: { hasFollowed } = {} } = await checkAPI({ id: fusionId, qbid });
  console.debug('=================makeRecheckSubscriptions关注状态2', qbid, !!hasFollowed);
  dispatch(hasFollowed ? subscribe(fusionId) : unsubscribe(fusionId));
  // if (hasFollowed) {
  // 检查后为关注态的情况下做个标记
  dispatch(checkSubscribed());
  // }
  synchState({ id: fusionId, state: !!hasFollowed, followCount: 0, loginTips: false });
};

export const showLoginPanel = async () => {
  const handkle = _.get(global, 'browser.login.showLoginPanel');
  if (!handkle) {
    return;
  }
  await new Promise((resolve, reject) => {
    handkle(
      resolve,
      (err) => {
        const toast = _.get(global, 'browser.app.toast');
        toast && toast(err);
        reject(err);
      },
      {
        appID: Number(_.get(isomorphicConfig, 'login.appId')),
      },
    );
  });
};

const makeUnsubscribe = ({ id, actType, ext }) => async (dispatch: Dispatch, getState: GetState) => {
  const {
    user: { qbid },
    grayConfig,
  } = getState();
  const needLogin = grayConfig.needLogin && grayConfig.needLogin.isAble;
  const toast = _.get(global, 'browser.app.toast');
  const unsubscribeFnc = async () => {
    const result = (await unsubscribeAPI({ id, actType, ext })) || {};
    if (result.retCode === 0) {
      dispatch(unsubscribe(id));
      synchState({ id, state: false });
      return true;
    }
    toast && toast(`取消关注失败${result.retCode}`);
    return;
  };
  if (!qbid && needLogin) {
    const userInfo = await qblogin.getSession(true);
    if (userInfo && userInfo.qbid) {
      return await unsubscribeFnc();
    }
    toast && toast('请登录后再操作');
    return;
  }
  return await unsubscribeFnc();
};

export const makeFetchRecommandCircles = ({ id, ...rest }: { id: string }) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const {
    user: { qbid },
  } = getState();
  const result = await fetchRecommandCircles({ ...rest, id, qbid });
  let recommandCircles = [];
  if (result && result.iRet === 0) {
    try {
      const listInfo = result.sData.replace(/[\r\n]/g, '');
      recommandCircles = JSON.parse(listInfo).circle_info_list;
    } catch (error) {
      console.log(error);
    }
  }
  if (recommandCircles.length) {
    // const pvInfo = recommandCircles.map((elem) => ({ circleId: elem.circle_id, inner: '600003', action: 'EXPOSURE', ch: currentChannel }));
    /* dispatch(
      makeTrack({
        location: 'article/attech',
        action: 'exposure',
        object: 'recommend',
        ext: `${recommandCircles.length}`,
      }),
    );*/
    // reportCirclePV(pvInfo);
    dispatch(updateCircles(recommandCircles));
  }
};

export const makeSubscribe = ({ id, actType, ext }: { id: string, actType?: number, ext?: {} }) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const { user, grayConfig } = getState();
  const needLogin = grayConfig.needLogin && grayConfig.needLogin.isAble;
  const toast = _.get(global, 'browser.app.toast');
  const subcribeFnc = async (info) => {
    console.log('~~~~~~~~~~~~info', info, needLogin);
    if (info.qbid || !needLogin) {
      const result = (await subscribeAPI({ id, actType, ext })) || {};
      if (result.retCode === 0 || result.retCode === 1) {
        dispatch(subscribe(id));
        dispatch(setFollow(true));
        synchState({
          id,
          state: true,
          followCount: _.get(result, 'followCount', 0),
          loginTips: _.get(result, 'loginTips', false),
        });
        return true;
      }
      toast && toast(`关注失败${result.retCode}`);
    }
    toast && toast('请登录后再操作');
    return;
  };
  let res = false;
  if (!user.qbid && needLogin) {
    const userInfo = await qblogin.getSession(true);
    res = await subcribeFnc({ qbid: userInfo.qbid });
  } else {
    res = await subcribeFnc(user);
  }
  return res;
};

export const checkLogin = ({ doLogin }: { doLogin: boolean }) => async (dispatch: Dispatch, getState: GetState) => {
  const {
    user: { circleUserId },
  } = getState();
  if (!circleUserId) {
    if (!doLogin) {
      return false;
    }
    await qblogin.getSession(doLogin);
    return true;
  }
  return true;
};

export const checkKdLogin = ({ doLogin }: { doLogin: boolean }) => async (dispatch: Dispatch, getState: GetState) => {
  const {
    user: { circleUserId },
  } = getState();
  if (!circleUserId) {
    if (!doLogin) {
      return false;
    }
    const result = await qblogin.getSession(doLogin).catch(() => false);
    return result;
  }
  return true;
};

export const getUser = () => (dispatch: Dispatch, getState: GetState) => {
  const { user } = getState();
  return user;
};
export const makeSwitchSubscription = ({ id, actType, ext, ...rest }: { id: string, actType?: number }) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const { user: { subscriptions } = {} } = getState();
  let queryId = '';
  let docId = '';
  let ch = '';
  if (window) {
    const { docId: docIdTmp, extenddata, ch: urlCh } = querystring.parse(location.search) || {};
    docId = docIdTmp;
    queryId = (querystring.parse(extenddata) || {}).queryId || '';
    ch = urlCh;
  }
  if (ext.reportObj && typeof ext.reportObj === 'object') {
    ext.reportObj.queryId = queryId;
    ext.reportObj.ch = ch;
    !ext.reportObj.docId && (ext.reportObj.docId = docId);
  } else {
    ext.reportObj = {
      queryId,
      docId,
      ch,
    };
  }

  if (subscriptions && subscriptions[id]) {
    return await dispatch(makeUnsubscribe({ id, actType, ext, ...rest }));
  }
  return await dispatch(makeSubscribe({ id, actType, ext, ...rest }));
};
// 检查用户福利中心任务是否领取
export const checkUserWelfareInfo = () => async (dispatch: Dispatch) => {
  const guid = cookies.get('qb_guid') || '';
  if (!guid) {
    console.log('guid不存在，无法开始活动');
    return;
  }
  const initTaskStart = async () => {
    let isFetch = true;
    if (!welfareInfoIsTimeLimit(`${guid}_welfare_isTask`)) {
      // 未过期, 直接开始，不再查询服务端
      isFetch = false;
      dispatch(
        resetWelfareInfo({
          taskStart: true,
        }),
      );
    }
    if (!welfareInfoIsTimeLimit(`${guid}_welfare_success`)) {
      // 早就完成, 结束
      isFetch = false;
    }
    if (isFetch) {
      // 过期，且未完成
      const result = await checkWelfareInfo({ guid });
      console.log('福利中心-查询服务', result);
      if (result && result.status === 2) {
        // processing
        console.log('福利中心-查询服务', '领取任务');
        dispatch(
          resetWelfareInfo({
            taskStart: true,
          }),
        );
        localStorage.setItem(`${guid}_welfare_isTask`, { code: 1, time: new Date().getTime() });
      } else {
        // toast && toast('未领取任务');
        console.log('福利中心-查询服务', '未领取任务');
      }
    } else {
      // toast && toast('从缓存中获取，领取任务');
    }
  };

  const getQua2 = _.get(window, 'browser.app.getQua2');
  if (getQua2 && typeof getQua2 === 'function') {
    getQua2((ret) => {
      let version = (ret && (querystring.parse(ret).VN || querystring.parse(ret).PPVN)) || '0';
      version = version.replace(/\./g, '');
      if (version.length > 7) {
        version = version.splice(0, 6);
      } else if (version.length < 7) {
        version = version.padEnd(7, '0');
      }
      version = Number(version);
      console.log('version==', version);
      if (isAndroid(window.navigator.userAgent) && version < 9304952) {
        // 9.3.0.4952,android要求这个小版本以下才显示前端挂件
        console.log('isAndroid==', version);
        initTaskStart();
      } else if (isIOS(window.navigator.userAgent) && version < 9400000) {
        // ios要求9.4以下显示
        console.log('isIos==', version);
        initTaskStart();
      }
    });
  } else {
    await initTaskStart();
  }
};
// 更新福利中心用户状态
export const updateUserWelfareInfo = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    user: { guid },
  } = getState();
  if (guid) {
    localStorage.setItem(`${guid}_welfare_isTask`, null); // 领任务记录
    localStorage.setItem(`${guid}_welfareInfo`, null); // 服务次数的记录
    localStorage.setItem(`${guid}_welfare_success`, { code: 1, time: new Date().getTime() }); // 是否已完成过记录
    localStorage.setItem(`${guid}_welfare_readMark`, null);
    localStorage.setItem(`${guid}_welfare_finish_result`, null);
    dispatch(
      resetWelfareInfo({
        taskStart: false,
      }),
    );
  }
};
const updateUserInfoByHours = async (key, fnc, callback) => {
  let result = {};
  const cache = localStorage.getItem(key);
  if (cache && cache.time === new Date().getHours()) {
    result = cache;
  } else {
    result = (await fnc().catch(() => undefined)) || {};
    if (result) {
      result.time = new Date().getHours();
      localStorage.setItem(key, result);
    }
  }
  callback && callback(result);
};
export const updateGSPProxy = () => async (dispatch: Dispatch) =>
  updateUserInfoByHours('USER_GSP', getGSPProxy, (result) => {
    dispatch(updateGSP(result));
  });
export const getPushWelfareData = (data: Object) => async (dispatch: Dispatch) => {
  const result = await getPushWelfare(data);
  dispatch(setPushWelfare(result));
};
// 拉取用户RMP平台配置信息
export const resetRMPInfo = () => async (dispatch: Dispatch) =>
  updateUserInfoByHours('USER_RMP', getProfileMatch, (result) => {
    dispatch(setRMPInfo(result));
  });
export const setFollow = (follow) => async (dispatch: Dispatch) => {
  dispatch(setFollowStatus(follow));
};
export const commentInput = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    user: { kdBigTReportInstance },
  } = getState();
  kdBigTReportInstance?.report('commentInput', {
    r2: 1,
    r3: 3,
    r5: {
      entry: 1,
      link_entry: 0,
      link_reply: 2,
      picture_reply: 2,
    },
  });
};
export const setPraise = (praise) => async (dispatch: Dispatch) => {
  listenToPostMessageReady(() => {
    postMessage({
      func: 'coolread.setPraiseInfo',
      data: { praised: praise, isClick: praise },
    });
  });
  dispatch(setPraiseStatus(praise));
};
export const setKdReportIns = (instance) => async (dispatch: Dispatch) => {
  dispatch(setKdReportInstance(instance));
};
